<template>
  <v-container>
    <v-dialog
      v-model="show"
      persistent
      max-width="700"
    >
      <v-card flat class="ma-0 pa-1">
        <v-card-title>
          分析を依頼する
          <v-spacer></v-spacer>
          <v-icon @click="close()" class="my-3 mx-2">mdi-close-circle </v-icon>
        </v-card-title>
        <v-card-subtitle>
          分析・診断サービスに申し込みます。
        </v-card-subtitle>
        <v-card-text class="mb-5 pb-0">
          <v-stepper
            v-model="e6"
            vertical
            editable
            class="ma-0"
          >
            <v-stepper-step :complete="e6 > 1" step="1" editable color="teal darken-1" class="ma-0 pa-2">
              分析依頼の種類
            </v-stepper-step>
            <v-stepper-content step="1">
              <div class="caption mb-2">分析を依頼する種類を選択して下さい。</div>
              <div class="caption mb-2">分析・診断サービスで依頼できる分析項目や報告書が変わります。</div>
              <v-btn
                color="amber"
                @click="selectAnalizeDypeGroup('一般')"
                class="my-3 mx-2"
                rounded
                x-large
                width="80%"
              >
                <v-icon class="mr-2" x-large>mdi-truck </v-icon>
                <v-icon class="mr-2" x-large>mdi-factory</v-icon>
                <div class="title font-weight-bold ml-2">一般</div>
                <div class="body-2">（航空機以外）</div>
              </v-btn>
              <div class="caption mb-2 ml-8" >一般的な分析項目での分析診断、報告書を作成を希望する</div>
              <div class="caption mb-2 ml-8">航空機以外の自動車や機械などはこちらを選択してください</div>

              <v-btn
                color="amber"
                @click="selectAnalizeDypeGroup('航空機')"
                class="my-3 mx-2"
                rounded
                x-large
                width="80%"
              >
                <v-icon class="mr-2" x-large>mdi-airplane</v-icon>
                <v-icon class="mr-2" x-large>mdi-helicopter</v-icon>
                <div class="title font-weight-bold ml-2">航空機</div>
              </v-btn>
              <div class="caption mb-2 ml-8">航空機専用の分析項目での分析診断、報告書を作成を希望する</div>
              <div class="caption mb-2 ml-8">飛行機やヘリコプターなどの航空機はこちらを選択してください。</div>

            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" step="2" color="teal darken-1" class="ma-0 pa-2">
              分析を依頼する
            </v-stepper-step>
            <v-stepper-content step="2" >
              <div class="title mb-2 font-weight-bold">
                「{{categoryText}}」の分析依頼を申し込みます。
              </div>
              <v-btn
                rounded
                color="amber"
                @click="gotoApplication()"
                class="my-3 mx-2"
              >
              <v-icon>mdi-checkbox-marked-circle</v-icon>次へ
              </v-btn>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
        <v-card-actions class="my-0 py-0">
        </v-card-actions>
      </v-card>

    </v-dialog>
  </v-container>
</template>

<script>

export default {
  name: "componentname",
  head: {
    title: { inner: 'タイトル'},
  },
  data() {
    return {
      show: true,
      e6: 1,
      formTitle: "select A",
      category: "",
      categoryText: "",
      machineType: "",
      machineTypeText: "",
    };
  },
  filters: {
  },
  computed: {
  },
  mounted: async function () {
  },
  methods: {
    selectAnalizeDypeGroup: function(category) {
      switch (category){
        case "航空機":
          this.categoryText = "航空機"
          break
        default:
          this.categoryText = "一般（航空機以外）"
          break
      }
      this.category = category
      this.e6 = 2
      return
    },

    gotoApplication: async function() {
      this.$router.push("/application?category=" + this.category)
      return true
    },
    close() {
      this.$router.back()
    },
  }
};
</script>
